
var $ = require('jquery');
var _ = require('lodash');
require('./hover');
var updateKlingBtn = require('./kling');
require('stats/stats')

module.exports = function (opts) {
    // opts:
    //   el               selector for the element to bind to
    //   overlay          selector of the overlay (default: no overlay)
    //   updateInterval   milliseconds (default: no autoupdate)
    //   date             initial date (default: today)
    //   link             which page to link to
    //   useHash          update based on URL hash (default: off)

    var $el, dates, loading, handle, url, $kling, goalCount;
    dates = {};
    $el = $(opts.el);
    goalCount = null;

    // This is tied to opts.date, toggle AJAX between subpages and index
    var sidebar = 0;

    var formatDate = function(date) {
        // Format yyyy-mm-dd. 0-padding is necessary for Firefox.
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth()+1).toString();
        var dd  = date.getDate().toString();
        return yyyy +'-'+ (mm[1]?mm:"0"+mm[0]) +'-'+ (dd[1]?dd:"0"+dd[0]);
    };


    var checkReverseTime = function() {
        if (!Modernizr.localstorage) {
            return;
        }
        if (localStorage.getItem('reverseTime') == 'true') {
            $('html').addClass('reverse-time');
        }
    };


    var updateDateData = function() {
        _.each($("#tulospalvelu .dates").children(), function(element) {
            dates[element.className] = new Date($(element).data('date'));
        });
    };

    var updateURL = function(date) {
        if (!date) {
            date = new Date();
        }
        var language = readActLang("django_language")
        url = '/'+ language +'/game-tracking/' + date.getFullYear()
            + '/' + (date.getMonth()+1)
            + '/' + date.getDate()
            + '/' + sidebar;
    };

    var getGoalCount = function() {
        return $el.find('.games').data('goals');
    };

    var render = function(data) {
        $el.html(data);

        updateDateData();

        $el.find('.game').css('visibility', 'visible');
    };

    var createKling = function() {
        return $('<audio id="kling"><source src="/static/liiga/common/audio/kling.wav" type="audio/wav"><source src="/static/liiga/common/audio/kling.ogg" type="audio/ogg"><source src="/static/liiga/common/audio/kling.mp3" type="audio/mpeg"></audio>');
    };

    var playKling = function() {
        var k = $kling.get(0);
        try {
            k.pause();
            k.currentTime = 0;
        } catch (err) {
            $kling.clone().get(0).play();
            return;
        }
        k.play();
    };

    var canPlayKling = function() {
        if (Modernizr.localstorage && localStorage.getItem('kling') == 'true') {
            return true;
        }
        return false;
    };

    var setTimer = function() {
        if (opts.updateInterval) {
            if (handle)
                window.clearInterval(handle);
            handle = window.setInterval(fetch, opts.updateInterval);
        }
    };

    var getHashShowState = function() {
        var showState = window.location.hash.substr(window.location.hash.length-1);
        if (showState === '_' || showState === '!') {
            return showState;
        }
        return null;
    };

    var getHashDate = function() {
        if (window.location.hash.length > 2) {
            var date = window.location.hash.substr(1);
            date = date.replace('_', '').replace('!', '');
            return date;
        }
        return null;
    };

    var fetch = function(date) {
        if (date)
            updateURL(date);

        return $.ajax({url: url, cache: false, dataType: 'html'})
            .done(fetchDone);
    };

    var fetchDone = function(games_html) {
        render(games_html);

        // Re-init, because the element changes
        initLoadingOverlay();

        updateKlingBtn();

        // Reset timer, so we don't accidentally
        // re-fetch right after changing day.
        setTimer();

        var newGoalCount = getGoalCount();
        if (goalCount !== null && goalCount < newGoalCount && canPlayKling()) {
            playKling();
        }

        goalCount = newGoalCount;
    };

    var initLoadingOverlay = function() {
        if (opts.overlay) {
            loading = $el.find('.overlay');
        } else {
            loading = $();  // empty
        }
    };

    var initClickHandlers = function() {

        // "Show games" arrow togglebutton
        if (opts.viewToggle) {
            $el.on('click', opts.viewToggle, function(e) {
                e.preventDefault();
                var showGames = !($el.hasClass('hide-games'));
                $el.toggleClass('hide-games', showGames);
                if (opts.useHash) {
                    var showStateChar = '';
                    if (showGames) {
                        showStateChar = '_';
                    } else if (!getHashDate()) {
                        showStateChar = '!';
                    }

                    if (getHashDate() && getHashShowState()) {
                        window.location.hash = getHashDate() + showStateChar;
                    } else if (getHashDate()) {
                        window.location.hash += showStateChar;
                    } else {
                        window.location.hash = showStateChar;
                    }
                }
            });
        }

        // All the date navigation buttons
        _.each(['prevprev', 'prev', 'current', 'next', 'nextnext'], function (key) {
            $el.on('click', ('.dates > .' + key), function () {
                if (key == 'current' || !dates[key]) {
                    // Disable clicking for current dates and those
                    // that are not available
                    return;
                }

                // Reset the current goalCount when changing the date.
                goalCount = null;
                var date = formatDate(dates[key]);

                var showState = getHashShowState();
                if (opts.useHash && showState) {
                    window.location.hash = date + showState;
                } else {
                    window.location.hash = date;
                }

                loading.show();
                fetch(new Date(date)).done(function () {
                    loading.hide();
                });
            });
        });
    };

    var init = function() {
        if (opts.useHash) {
            var showState = getHashShowState();
            if (showState == '_') {
                $el.addClass('hide-games');
            } else if (showState == '!') {
                $el.removeClass('hide-games');
            }
         }

        // Initialize index page, with different dates (from url hash)
        if (opts.useHash && getHashDate()) {
            initLoadingOverlay();
            loading.show();
            fetch(new Date(getHashDate()));
            initClickHandlers();
            initLoadingOverlay();

        // Initialize subpages (roster, stats, etc.)
        } else if (opts.date) {
            sidebar = 1;
            updateURL(new Date(opts.date));
            goalCount = getGoalCount();

        // Initialize normal index page, with current date
        } else {
            updateURL();
            updateDateData();
            initClickHandlers();
            initLoadingOverlay();
        }

        $kling = createKling();
        $('body').append($kling);

        setTimer();

        checkReverseTime();
    };

    init();
};



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/common/js/game-tracking.js
// module id = 5
// module chunks = 0